const heroBannerSlider = document.querySelector('#heroHomeBannerSlider');
let slider;

document.addEventListener('DOMContentLoaded', async () => {
    slider = await initSlider(heroBannerSlider);
    attachPageDots(slider);
});

const initSlider = async (heroBannerSlider) => {
    const splide = await buildSlider(heroBannerSlider);
    setSlideHeight(); // Set initial height after DOM loads
    setTimeout(() => {
        setSlideHeight(); // Set height again after images load
    }, 1000);
    return splide;
}

const buildSlider = async (heroBannerSlider) => {
    const splide = new Splide(heroBannerSlider, {
        type: 'loop',
        perPage: 1,
        autoplay: false,
        arrows: false,
        pauseOnHover: true,
        pauseOnFocus: true,
        pagination: false,
        breakpoints: {
            1200: {
                pagination: true,
            }
        }
    }).mount();

    splide.on('move', function (newIndex) {
        // Update the additional content based on the current slide index
        updateAdditionalContent(newIndex);
    });

    // Attach 'moved' event to the Splide instance.
    splide.on('moved', () => {
        setSlideHeight();
    });

    const prevButton = heroBannerSlider.querySelector('#slide_button_prev');
    const nextButton = heroBannerSlider.querySelector('#slide_button_next');
    prevButton.addEventListener('click', () => {
        splide.go('<');
    });
    nextButton.addEventListener('click', () => {
        splide.go('>');
    });

    return splide;
}

const updateAdditionalContent = (index) => {
    // Hide all additional content elements
    let additionalContents = document.querySelectorAll('.slider-content');
    additionalContents.forEach(function (content) {
        content.classList.add('hidden');
    });

    // Show the additional content corresponding to the current slide index
    let currentContent = document.querySelector('.slider-content[data-index="' + index + '"]');
    if (currentContent) {
      currentContent.classList.remove('hidden');
    }
  }

const attachPageDots = (slider) => {
    let pageDotContainers = document.querySelectorAll('#pageDots');
    pageDotContainers.forEach(pageDotContainer => {
        let pageDots = pageDotContainer.querySelectorAll('.page-dot');
        pageDots[0].classList.add('active--pagedot');

        slider.on('moved', (index) => {
            pageDots.forEach((dot, i) => {
                if (i === index) {
                    dot.classList.add('active--pagedot');
                } else {
                    dot.classList.remove('active--pagedot');
                }
            });
        });
    });
}

const setSlideHeight = () => {
    if (slider) {
        setTimeout(() => {
            let currentSlide = slider.Components.Elements.track.querySelector('.splide__slide.is-active.is-visible');
            let slideTrack = slider.Components.Elements.track;
            if (currentSlide) {
                let currentSlideHeight = currentSlide.offsetHeight;
                slideTrack.style.height = `${currentSlideHeight}px`;
            }
        }, 0);
    }
};

window.addEventListener('resize', () => {
    setSlideHeight();
});
